<script>
	export let style = null;
	let className = $$props.class ? $$props.class : "";
</script>

<div class="row{!className ? '' : ' ' + className}" {style}><slot></slot></div>

<style>
	.row {
		margin-top: 0px;
	}

	@media (min-width: 768px) {
		.row {
			margin-top: 36px;
		}
	}
</style>
